import * as React from "react";
const SvgFiRrToothbrush = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M24 3v-.412c0-.627-.373-1.191-.951-1.44a1.54 1.54 0 0 0-1.669.3A1.99 1.99 0 0 1 20 2H6.693A6.96 6.96 0 0 0 .181 6.43a2.58 2.58 0 0 0 .273 2.406A2.65 2.65 0 0 0 2.648 10H3v8c-1.654 0-3 1.346-3 3s1.346 3 3 3h20a1 1 0 1 0 0-2H3a1 1 0 0 1 0-2h20a1 1 0 1 0 0-2h-2V8.74A7 7 0 0 0 24 3M2.107 7.71a.58.58 0 0 1-.067-.546A4.98 4.98 0 0 1 6.693 4H20c.703 0 1.381-.182 1.978-.521a5.006 5.006 0 0 1-4.976 4.52H2.648a.65.65 0 0 1-.541-.288M11 10v8H9v-8zm2 0h2v8h-2zm-8 0h2v8H5zm14 8h-2v-8h.002c.694 0 1.365-.102 1.998-.291z"
    />
  </svg>
);
export default SvgFiRrToothbrush;
